import React, { useState, useEffect } from "react";
import {
  useTemplateSaleHistoryList,
  useTemplateSaleHistoryStats,
} from "../../../../api/hooks/sales-history";
import { getPrice } from "../../../../utils";

import "../../../../scss/dashboard/payment.scss";
import PaymentModal from "./paymentModal";
function Payment({ balance, puntos, handleEditar, cuenta }) {
  const { data: pendingSales } = useTemplateSaleHistoryList({
    isRedeemed: false,
    perPage: 10,
  });
  const { data: paidSales } = useTemplateSaleHistoryList({
    isRedeemed: true,
    perPage: 10,
  });
  const { data: stats = {} } = useTemplateSaleHistoryStats();
  const [paymentModalIs, setPaymentModal] = useState(false);
  const monthDictionary = [
    "EN",
    "FEB",
    "MZO",
    "ABR",
    "MY",
    "JUN",
    "JUL",
    "AGT",
    "SEPT",
    "OCT",
    "NOV",
    "DIC",
  ];

  return (
    <div className="lawyersPayment__layout">
      <PaymentModal
        balance={balance / 100}
        modal={paymentModalIs}
        handleClose={() => setPaymentModal(false)}
        isValid={cuenta?.length > 0}
      />
      <div className="row1">
        <div className="saldoTotal">
          <div className="header">
            <h5 className="title">Saldo Total</h5>
            <br />
            <span className="balance">
              {getPrice(stats.balance, "mxn", false, true)}
            </span>
          </div>
          <div className="desglose">
            <h5>Desglose</h5>
            <br />

            <div className="sumary">
              <span className="label">Saldo de este mes</span>{" "}
              <span className="cantidad">
                {getPrice(stats.balanceThisMonth, "mxn", false, true)}
              </span>
            </div>
            <div className="sumary">
              <span className="label">Comisión TRATO</span>{" "}
              <span className="cantidad">
                {getPrice(stats.feeThisMonth, "mxn", false, true)}
              </span>
            </div>
            <div className="sumary">
              <span className="labelBold">Total de este mes</span>{" "}
              <span className="cantidad">
                {getPrice(stats.totalThisMonth, "mxn", false, true)}
              </span>
            </div>
          </div>
          <div className="button">
            <button
              disabled={!balance || balance < 500}
              style={!balance || balance < 500 ? { opacity: 0.7 } : {}}
              onClick={() => setPaymentModal(true)}
            >
              Cobrar
            </button>
          </div>
          <div className="legend">
            <p>Cantidad minima para cobrar es de $500</p>
          </div>
        </div>
        <div className="puntos">
          <div className="header">
            <h5>Puntos</h5>
          </div>
          <div className="count">
            <span>{puntos} PTS</span>
          </div>
          <div className="canjearButton">
            {/* <div className="button">
              <span>Canjear</span>
            </div> */}
          </div>
        </div>
        <div className="formaDePago">
          <div className="header">
            <h5>Forma de Pago</h5>
          </div>
          <div className="tipo">
            <span>Transferencia Bancaria</span>
          </div>
          <div className="cuenta">
            <div>
              <span className="label">Cuenta CLABE</span>
              <br />
              <span className="clabe">
                {cuenta ? cuenta : "Sin cuenta CLABE registrada"}
              </span>
            </div>
          </div>
          <div className="editButton">
            <span onClick={handleEditar}>Editar</span>
          </div>
        </div>
      </div>
      <div className="row2">
        <div className="pendientes">
          <div className="header">
            <h5>Pendientes</h5>
          </div>
          <div className="childContainer">
            {pendingSales?.data && pendingSales?.data?.length > 0 ? (
              pendingSales?.data?.map((item) => (
                <PayHistoryElement
                  month={
                    monthDictionary[item.createdAt.slice(6, 7).valueOf() - 1]
                  }
                  day={item.createdAt.slice(8, 10)}
                  elementType={"pendingSales"}
                  summary={getPrice(item.profit, "", false, true)}
                  category={"Plantilla"}
                  templateName={
                    item.name.length <= 38
                      ? item.name
                      : item.name.slice(0, 38) + "..."
                  }
                />
              ))
            ) : (
              <div className="noInfo">
                <p>No hay pagos pendientes</p>
              </div>
            )}
          </div>
        </div>
        <div className="pagados">
          <div className="header">
            <h5>Pagados</h5>
          </div>

          <div className="childContainer">
            {paidSales?.data && paidSales?.data?.length > 0 ? (
              paidSales?.data?.map((item) => (
                <PayHistoryElement
                  month={
                    monthDictionary[item.createdAt.slice(6, 7).valueOf() - 1]
                  }
                  day={item.createdAt.slice(8, 10)}
                  elementType={"paidSales"}
                  summary={getPrice(item.profit, "", false, true)}
                  category={"Plantilla"}
                  templateName={
                    item.name.length <= 38
                      ? item.name
                      : item.name.slice(0, 38) + "..."
                  }
                />
              ))
            ) : (
              <div className="noInfo">
                <p>Sin Información para mostrar</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;

function PayHistoryElement({
  month,
  day,
  templateName,
  category,
  summary,
  elementType,
}) {
  return (
    <div className="payHistoryElement">
      <div className="payHistoryElement__date">
        <p>{month}</p>

        <p>{day}</p>
      </div>
      <div className="payHistoryElement__info">
        <p className="element1">{templateName}</p>
        <p className="element2">{category}</p>
      </div>
      <div className="payHistoryElement__summary">
        <p className={`summary ${elementType}`}>{`${
          elementType === "pendingSales"
            ? "+"
            : elementType === "paidSales" && "-"
        } ${summary}`}</p>
        <br />
        <span>{"MX"}</span>
      </div>
    </div>
  );
}
